var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"containerWindow"},[_c('p',[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"p-4",staticStyle:{"display":"flex","align-items":"center"},on:{"click":_vm.deleteFile}},[_c('b-icon',{attrs:{"icon":"delete"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }